var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"adLine"},_vm._l((_vm.showList),function(item,index){return _c('el-image',{key:index,staticClass:"adItem",attrs:{"src":item.tabImageUrl,"fit":'cover'},on:{"click":function($event){return _vm.onJump(item)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }